import React from 'react'

const Menus = () => {
  return (
    <div>메뉴페이지</div>
  )
}

export default Menus